<template>
  <div class="pb-10 md:grid md:grid-cols-5">
    <!-- LEFT TEXT SECTION -->
    <div class="col-span-3 flex items-center justify-center px-6 md:pl-32 mt-6 md:mt-0">
      <div class="flex flex-col">
        <h1 class="md:text-left text-center py-10 text-black text-4xl font-extrabold">Who we are</h1>

        <div class="space-y-4 text-gray-700 text-base leading-7 text-center md:text-left">
          <p>
            Interfaced Medical Facilities (IMF) is a comprehensive healthcare service provider committed to delivering accessible, efficient, and patient-centered medical solutions
            through advanced teleconsultation technology. We bridge the gap between patients and healthcare professionals by offering a platform that allows individuals to receive
            medical attention anytime, anywhere—without the need for physical clinic visits.
          </p>

          <p>
            IMF was established with the mission of making healthcare more convenient and responsive to the needs of modern-day patients. Through our digital telecons platform, we
            ensure that people can consult licensed doctors, receive medical guidance, and gain access to health services from the comfort of their homes or workplaces. By
            integrating secure communication systems, user-friendly features, and reliable support, we aim to create a seamless healthcare experience for all.
          </p>
        </div>
      </div>
    </div>

    <!-- RIGHT IMAGE SECTION (HIDDEN ON MOBILE) -->
    <div class="hidden md:flex col-span-2 items-center justify-end pt-10 px-16">
      <div class="relative">
        <!-- Doctor Image -->
        <img class="h-96 w-auto" :src="require('@/assets/images/doctor.png')" alt="Doctor" />

        <!-- Floating Review Card -->
        <div
          class="absolute top-0 right-0 w-52 bg-white/50 backdrop-blur-md text-gray-700 px-4 py-3 rounded-2xl border border-white/40 shadow-[0_0_20px_rgba(0,0,0,0.1)] animate-bounce-slow"
        >
          <div class="flex flex-col">
            <div class="flex h-full gap-2.5">
              <img class="w-7 h-6" :src="require('@/assets/images/iwc.png')" alt="IWC Logo" />
              <div class="flex flex-col">
                <span class="text-sm">IMS Wellth Care, Inc</span>
                <div class="flex">
                  <SVGStar v-for="n in 4" :key="n" class="w-4 h-4" />
                </div>
              </div>
            </div>
            <p class="text-xs">Partnering with IMF lets us deliver fast, reliable care anytime, anywhere. It’s healthcare beyond the clinic.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SVGFacebook from "@/components/svgs/facebook.vue";
import SVGStar from "@/components/svgs/star.vue";

export default {
  components: {
    SVGFacebook,
    SVGStar,
  },
};
</script>
